export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),

  onInit() {
    this.store.resetLocalStorage()
  },
})
